import { useContext } from "react";
import MasterSearchContext from "./masterSearch.context";

const useMasterSearchContext = () => {
  return useContext(MasterSearchContext);
};

export default useMasterSearchContext;
